export default "/_next/static/fonts/e723daac0fb0be4417cb6110dbe331d7.woff2";